module.exports = __webpack_public_path__ + "img/icon_dining.e0c21127.svg";